import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appSelectOnFocus]'
})
export class SelectOnFocusDirective {

  constructor() { }

  @HostListener('click', ['$event', '$event.target'])
  onClick(event: MouseEvent, el: HTMLInputElement | HTMLTextAreaElement) {
    el.select();
  }
}
